<div class="auth">
  @if (authSentence) {
    <div class="form-header grid-row grid-row-2 grid-gap-20 d-lg-flex d-block pl20">
      @if (authImage || authShortName) {
        <div class="list-card">
          <div class="profile-images">
            <div class="profile-images-photo profile-images-photo-60">
              @if (authImage) {
                <b
                  [ngStyle]="{
                    'background-image': 'url(' + authImage + ')',
                  }"></b>
              }
              @if (!authImage) {
                <b>
                  {{ authShortName }}
                </b>
              }
            </div>
          </div>
        </div>
      }
      <div
        class="appointment-details pt20-lg"
        [ngStyle]="!authImage && !authShortName ? { borderLeft: 'none' } : ''">
        {{ authSentence }}
      </div>
    </div>
  }
  @if (state === AuthenticationState.LogIn) {
    <core-auth-login
      (forgotPasswordEmitter)="switchToForgotPassword()"
      (loginSelectionEmitter)="switchToLoginSelection()"
      (emailConfirmationEmitter)="switchToEmailConfirmation()"
      (oneTimeLoginEmailEmitter)="switchToOneTimeLoginEmail()"
      (oneTimeLoginSmsEmitter)="switchToOneTimeLoginSms()"
      (closeModalEmitter)="closeModal()"
      [canReturn]="canReturn"
      [previousCanReturn]="previousCanReturn"
      [loginType]="loginType">
    </core-auth-login>
  }
  @if (state === AuthenticationState.ForgotPassword) {
    <core-auth-forgot-password (loginEmitter)="switchToLogin()" (closeModalEmitter)="closeModal()">
    </core-auth-forgot-password>
  }
  @if (
    state === AuthenticationState.OneTimeLoginEmail ||
    state === AuthenticationState.OneTimeLoginSms ||
    state === AuthenticationState.ReceptionCode
  ) {
    <core-auth-one-time-code-login
      (loginEmitter)="switchToLogin()"
      (loginSelectionEmitter)="switchToLoginSelection()"
      (closeModalEmitter)="closeModal()"
      [canReturn]="canReturn"
      [previousCanReturn]="previousCanReturn"
      [previousState]="previousState"
      [state]="state"
      [loginType]="loginType">
    </core-auth-one-time-code-login>
  }
  @if (state === AuthenticationState.LoginSelection) {
    <core-auth-login-selection
      (closeModalEmitter)="closeModal()"
      (emailConfirmationEmitter)="switchToEmailConfirmation()"
      (setLoginTypeEmitter)="setLoginType($event)"
      [loginType]="loginType">
    </core-auth-login-selection>
  }
  @if (state === AuthenticationState.EmailConfirmation) {
    <core-auth-email-confirmation
      (loginSelectionEmitter)="switchToLoginSelection()"
      (loginEmitter)="switchToLogin()"
      (closeModalEmitter)="closeModal()"
      [canReturn]="canReturn"
      [previousState]="previousState"
      [previousCanReturn]="previousCanReturn">
    </core-auth-email-confirmation>
  }
  @if (state === AuthenticationState.ExternalSSO) {
    <core-auth-external-sso [ssoInfo]="ssoInfo"> </core-auth-external-sso>
  }
</div>
